import * as SomaPlaceService from "./SomaPlaceServer";
export default SomaPlaceService;
